import axios from 'axios';
import { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';

import { Button, Input } from '../../components';
import { MatchParams } from '../../Routes';
import Result, { ResultData } from './Result';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  & > input {
    margin-bottom: 15px;
  }
`;

const Landing: FC = () => {
  const { identifier } = useParams<MatchParams>();
  const history = useHistory();

  const [isFetching, setIsFetching] = useState(false);
  const [value, setValue] = useState('');

  const [result, setResult] = useState<ResultData>();

  const fetchResult = (key: string) => {
    setIsFetching(true);

    axios({
      headers: { 'Content-Type': 'application/json' },
      method: 'post',
      url: `https://young-thicket-56542.herokuapp.com/https://bitclout.com/api/v0/get-users-stateless`,
      data: { PublicKeysBase58ChecK: [key] },
    })
      .then((res) => {
        if (res.data?.UserList[0]?.ProfileEntryResponse)
          return setResult(res?.data?.UserList[0]);
        return setResult(undefined);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsFetching(false));
  };

  useEffect(() => {
    if (!identifier) return;

    setValue(identifier);
    fetchResult(identifier);
  }, [identifier]);

  return (
    <Container>
      <Input
        disabled={isFetching}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Public Key"
        value={value}
      />
      <Button
        disabled={isFetching}
        onClick={() =>
          identifier === value
            ? fetchResult(value)
            : history.push(`/u/${value}`)
        }
      >
        {isFetching ? 'Loading...' : 'Check Blacklist Status'}
      </Button>

      {identifier && !isFetching && <Result result={result as ResultData} />}
    </Container>
  );
};

export default Landing;
